export default __webpack_public_path__ + "static/media/wrzesien.f53fd957.mp3";